type ProfileDetailItemProps = {
  label: string
  labelWidth?: string
  children: React.ReactNode
}
export default function ProfileDetailItem({
  label,
  labelWidth,
  children,
}: ProfileDetailItemProps) {
  return (
    <div className="detail-item-wrap">
      <div className="detail-item-label">{label}</div>
      <div className="detail-item-value">{children || "--"}</div>
      <style jsx>{`
        .detail-item-wrap {
          display: flex;
          align-items: flex-start;
          line-height: 34px;
          width: 100%;
        }
        .detail-item-label {
          font-size: 14px;
          color: #999999;
          flex: 0 0 ${labelWidth};
        }
        .detail-item-value {
          font-size: 14px;
          color: #333333;
        }
      `}</style>
    </div>
  )
}
